export const useWarrantyStore = defineStore("warranty", {
  state: () => ({
    faultyParts: [],
  }),

  actions: {
    async fetchFaultyParts() {
      try {
        const { data } = await useAPI("/api/front/warranty-inquiry/get-attributes");

        this.faultyParts = data._rawValue ? data._rawValue : [];

      } catch (e) {
        console.log(e)
      }
    },
  },
});